import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export interface PersonalNotif { id: string; type: string; icon: string; message: string; link: string | null; createdAt: string; readAt: string | null }
export interface ProjectAlertNotif { id: string; type: string; icon: string; message: string; project?: { id: string; code: string; name: string } | null; createdAt: string }
export interface NotificationsPayload {
  personal: PersonalNotif[];
  projectAlerts: ProjectAlertNotif[];
  unreadCount: number;
}

/**
 * Fonte unica per le notifiche (campanella Topbar + card "Cose da fare" in
 * Dashboard): stessa queryKey ['notifications'], polling 30s e refetch al
 * ritorno sul tab — un solo fetch condiviso via TanStack Query cache.
 */
export function useNotifications() {
  return useQuery({
    queryKey: ['notifications'],
    queryFn: () => api.get<NotificationsPayload>('/notifications'),
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
  });
}
